/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import DragNodeDataset from './dragnode';
import { pluck, pluckNumber, getValidValue, parseUnsafeString, getDashStyle, HUNDREDSTRING, DASH_DEF,
  preDefStr, BLANK, toRaphaelColor, POINTER, BLANKSTRING, SHAPE_RECT, parseTooltext, getFirstColor } from '@fusioncharts/core/src/lib';
import { addDep } from '@fusioncharts/core/src/dependency-manager';
import connectorAnimation from './connector-animation';

let
  EVENTARGS = preDefStr.EVENTARGS,
  L = 'L',
  M = 'M',
  configStr = preDefStr.configStr,
  _getlinePath = function (connector) {
    var config = connector.config,
      fromPointObj = config.fromPointObj,
      toPointObj = config.toPointObj,
      fromX = config.fromX,
      fromY = config.fromY,
      toX = config.toX,
      toY = config.toY,
      path = [M, fromX, fromY],
      pointConfig;

    if (config.arrowAtStart) {
      pointConfig = fromPointObj.config;
      if (pointConfig.shapeType === SHAPE_RECT) {
        path = path.concat(DragNodeConnector._drawArrow(fromX, fromY, toX, toY,
          pointConfig.shapeArg.width, pointConfig.shapeArg.height));
      } else {
        path = path.concat(DragNodeConnector._drawArrow(fromX, fromY, toX, toY,
          pointConfig.shapeArg.radius));
      }
    }

    // Calculating path for connector Arrow
    if (config.arrowAtEnd) {
      pointConfig = toPointObj.config;
      if (pointConfig.shapeType === SHAPE_RECT) {
        path = path.concat(DragNodeConnector._drawArrow(toX, toY, fromX, fromY,
          pointConfig.shapeArg.width, pointConfig.shapeArg.height));
      } else {
        path = path.concat(DragNodeConnector._drawArrow(toX, toY, fromX, fromY,
          pointConfig.shapeArg.radius));
      }
    }
    path.push(L, toX, toY);
    return path;
  },
  /**
   * Helper function to create a RedRaphael group.
   * @param  {string} groupName                Name of the group to be created.
   * @param  {Element} parentContainer         The parent container in which the group will be appended.
   * @param {Object} dataset The concerned dataset
   * @return {Element}                         The group that was created.
   */
  createGroup = function (groupName, parentContainer, dataset) {
    var animationManager = dataset.getFromEnv('animationManager');
    return animationManager.setAnimation({
      el: 'group',
      attr: { name: groupName },
      container: parentContainer,
      component: dataset,
      label: 'group'
    });
  };

addDep({
  name: 'connectorAnimation',
  type: 'animationRule',
  extension: connectorAnimation
});
/**
 * dataset class of dragcolumn inheriting from column class
 */
class DragNodeConnector extends DragNodeDataset {
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'dragNodeConnector';
  }

  /**
   * Function to set the index of the dataset from amongst the other datasets
   */
  _setDatasetIndex () {
    var dataset = this,
      chidrenArr = dataset.getLinkedParent().getChildren('connector');
    dataset.config.datasetIndex = chidrenArr.indexOf(dataset);
  }
  /**
    * Function for parsing all the attributes and value given by the user at chart and dataset level.
    * @param  {Object} datasetJSON JSON for dataset configurations
    * @return {boolean} if no datasetJSON is found
    */
  configureAttributes (datasetJSON) {
    if (datasetJSON) {
      this.trimData(datasetJSON);
      this.config.JSONData = datasetJSON;
    } else if (!datasetJSON && !this.config.JSONData) {
      return false;
    }

    var connectors = this,
      // chartObj = connectors.chart,
      // rawData = connectors.jsonData,
      chartAttr = connectors.getFromEnv('chart-attrib'),
      conf = connectors.config,
      // dataStore = connectors.components.data || (connectors.components.data = []),
      // dataStoreLen,
      connectorsObj = connectors.config.JSONData,
      connectorsArr = connectorsObj.connector,
      length = connectorsArr && connectorsArr.length,
      index,
      // seriesConnector,
      HUNDRED = HUNDREDSTRING;

    conf.connectorsTooltext = getValidValue(parseUnsafeString(pluck(
      connectorsObj.connectortooltext, chartAttr.connectortooltext), false));

    // Extract attributes of this node.
    conf.stdThickness = pluckNumber(connectorsObj.stdthickness, 1);
    conf.conColor = getFirstColor(pluck(connectorsObj.color, 'FF5904'));
    conf.conAlpha = pluck(connectorsObj.alpha, HUNDRED);
    conf.conDashGap = pluckNumber(connectorsObj.dashgap, 5);
    conf.conDashLen = pluckNumber(connectorsObj.dashlen, 5);
    conf.conDashed = Boolean(pluckNumber(connectorsObj.dashed, 0));
    conf.arrowAtStart = Boolean(pluckNumber(connectorsObj.arrowatstart, 1));
    conf.arrowAtEnd = Boolean(pluckNumber(connectorsObj.arrowatend, 1));
    conf.conStrength = pluckNumber(connectorsObj.strength, 1);
    conf.toolTipSepChar = pluck(chartAttr.tooltipsepchar, ' - ');
    // seriesConnector = connectors.connector;
    conf.showTooltip = pluckNumber(chartAttr.showtooltip, 1);
    conf.showTextOutline = pluckNumber(chartAttr.textoutline, 0);
    conf.viewMode = pluckNumber(chartAttr.viewmode, 1);

    // dataStoreLen = dataStore.length;

    // if (dataStoreLen > length) {
    //     dataStore.splice(length, dataStoreLen - length);
    // }
    conf._refreshData = true;
    connectors._setDatasetIndex('connector'); // set the datasetIndex of the connectors
    for (index = 0; index < length; index += 1) {
      this._setConfigure(index, connectorsArr[index]);
    }
    conf._refreshData = true;
  }

  /**
   * Function for parsing all the attributes and value given by the user at set level.
   * @param {number} index The data index for which the configuration is to be parsed.
   * @param {Object} connectorObj It has the information of the data given by the user at the set level
   */
  _setConfigure (index, connectorObj) {
    // connector label.
    var connector = this,
      connectorStore = connector.components.data || (connector.components.data = []),
      connObj = connectorStore[index] || (connectorStore[index] = connectorStore[index] = {}),
      conf = connector.config,
      // chartObj = connector.chart,
      connectorLabel = parseUnsafeString(pluck(connectorObj.label, connectorObj.name)),
      setConAlpha = pluck(connectorObj.alpha, conf.conAlpha),
      smartLabel = connector.getFromEnv('smartLabel'),
      tooltipSepChar = conf.toolTipSepChar,
      defToolTextMacro = '$fromLabel' + tooltipSepChar + '$toLabel',
      setConColor = {
        FCcolor: {
          color: getFirstColor(pluck(connectorObj.color, conf.conColor)),
          alpha: setConAlpha
        }
      },
      toolText,
      config,
      labelTextObj,
      connectorsTooltext = conf.connectorsTooltext,
      connectorToolText = getValidValue(parseUnsafeString(pluck(connectorObj.tooltext,
        connectorsTooltext), false)),
      boolCondition = Boolean(pluckNumber(connectorObj.dashed, conf.conDashed));

    smartLabel.setStyle(connector.getFromEnv('dataLabelStyle'));
    smartLabel.useEllipsesOnOverflow(connector.getFromEnv('chartConfig').useEllipsesWhenOverflow);
    labelTextObj = smartLabel.getOriSize(connectorLabel);
    config = connObj.config = connObj.config || (connObj.config = {});
    !connObj.graphics && (connObj.graphics = {});
    // create the tooltext
    if (!conf.showTooltip) {
      toolText = false;
    } else { // determine the tooltext then
      toolText = pluck(connectorToolText, connectorLabel
        ? '$label' : defToolTextMacro);
    }
    config = connObj.config = {
      _options: connectorObj,
      id: pluck(connectorObj.id, index).toString(),
      from: pluck(connectorObj.from, BLANK),
      to: pluck(connectorObj.to, BLANK),
      label: connectorLabel,
      toolText: toolText,
      customToolText: connectorToolText,
      color: setConColor,
      index: index,
      dashStyle: boolCondition
        ? getDashStyle(pluckNumber(connectorObj.dashlen, conf.conDashLen),
          pluckNumber(connectorObj.dashgap, conf.conDashGap)) : DASH_DEF,
      dashed: connectorObj.dashed,
      dashlen: connectorObj.dashlen,
      dashgap: connectorObj.dashgap,
      arrowAtStart: Boolean(pluckNumber(connectorObj.arrowatstart, conf.arrowAtStart)),
      arrowAtEnd: Boolean(pluckNumber(connectorObj.arrowatend, conf.arrowAtEnd)),
      conStrength: pluckNumber(connectorObj.strength, conf.conStrength),
      link: connectorObj.link,
      stdThickness: conf.stdThickness,
      labelWidth: labelTextObj.widht,
      labelHeight: labelTextObj.height
    };
    config.datasetIndex = connector.config.datasetIndex;
    config.add = connectorObj.add;
    config.update = connectorObj.update;

    config.dataLabelStyle = connector._configureDataLabelStyle(connectorObj);
    if (conf._refreshData) {
      delete connObj.removed;
    }
  }

  /**
   * Function to create container at the dataset level
   */
  createContainer () {
    var dataset = this,
      parentContainer = dataset.getLinkedParent().getChildContainer();

    !dataset.getContainer('connectorGroup') && dataset.addContainer('connectorGroup',
      createGroup('connectorGroup', parentContainer.connectorGroup, dataset));

    !dataset.getContainer('connectorDataLabelGroup') && dataset.addContainer('connectorDataLabelGroup',
      createGroup('connectorDataLabelGroup', parentContainer.connectorGroup, dataset));
  }

  /**
   * Function ot draw the entire dataset
   */
  draw () {
    var connectors = this,
      // chart = connectors.chart,
      manager = connectors.getLinkedParent(),
      conf = connectors.config,
      // chartObj = connectors.chart,
      // chartComp = chartObj.components,
      // chartGraphics = chart.graphics,
      // nodes = manager.nodes,
      connectorStore = connectors.components.data,
      connector,
      fromId,
      toId,
      // paper = connectors.getFromEnv('paper'),
      // jobList = chart.getJobList(),
      // datasetGroup = chartGraphics.datasetGroup,
      fromPointObj,
      toPointObj,
      style = connectors.getFromEnv('dataLabelStyle'),
      // graphics,
      i,
      length = connectorStore.length,
      removeDataArr = connectors.components.removeDataArr || [],
      removeDataArrLen = removeDataArr.length,
      // connectorsGroup,
      config;

    // if (!connectorsGroup) {
    //     connectorsGroup = connectors.graphics.connectorGroup =
    //         connectors.graphics.connectorGroup || paper.group('connectorGroup').insertBefore(datasetGroup);
    // }

    connectors.createContainer();
    // connectorsGroup = connectors.getContainer('connectorGroup');

    conf.cleared = false;
    connectors.getContainer('connectorDataLabelGroup').css(style);
    for (i = 0; i < length; i++) {
      connector = connectorStore[i];
      config = connector.config;
      // graphics = connector.graphics || (connector.graphics = {});
      fromId = config.from;
      toId = config.to;
      fromPointObj = manager.getNode(fromId);
      toPointObj = manager.getNode(toId);
      if (fromPointObj && toPointObj && config.deleted !== true) {
        connectors.drawConnector(connector, fromPointObj, toPointObj, i);
      }
    }
    connectors.config.drawn = true;

    for (i = 0; i < removeDataArrLen; i++) {
      connectors._removeDataVisuals(removeDataArr.shift());
    }
  }

  /**
   * Parsing and calculation of attributes takes place
   *
   * @param {any} connector connector
   * @param {any} fromPointObj from node
   * @param {any} toPointObj to node
   * @memberof DragNodeConnector
   */
  parsePlotAttributes (connector, fromPointObj, toPointObj) {
    var dataset = this,
      fromX,
      toX,
      fromY,
      toY,
      strokeWidth,
      NumberFormatter = dataset.getFromEnv('number-formatter'),
      pathArr,
      startConnectors,
      endConnectors,
      config = connector.config,
      fromConf,
      toConf,
      eventArgs = config.eventArgs || (config.eventArgs = {}),
      color,
      id;

    config.fromPointObj = fromPointObj;
    config.toPointObj = toPointObj;
    fromConf = fromPointObj.config;
    toConf = toPointObj.config;
    config.fromX = fromX = fromConf._xPos;
    config.fromY = fromY = fromConf._yPos;
    config.toX = toX = toConf._xPos;
    config.toY = toY = toConf._yPos;
    config._labelX = (fromX + toX) / 2;
    config._labelY = (fromY + toY) / 2;
    config.strokeWidth = strokeWidth = (config.conStrength * config.stdThickness);
    color = config.color;
    config.textBgColor = color && color.FCcolor &&
        color.FCcolor.color;
    eventArgs.label = config.label;
    eventArgs.arrowAtStart = config.arrowAtStart;
    eventArgs.arrowAtEnd = config.arrowAtEnd;
    eventArgs.link = config.link;
    eventArgs.id = config.id;
    eventArgs.fromNodeId = fromConf.id;
    eventArgs.toNodeId = toConf.id;
    config.toolText = parseTooltext(config.toolText, [3, 83,
      84, 85, 86, 87, 88, 89, 90, 91, 92
    ], {
      label: config.label,
      fromXValue: NumberFormatter.dataLabels(fromPointObj.config.x),
      fromYValue: NumberFormatter.dataLabels(fromPointObj.config.y),
      fromXDataValue: fromPointObj.config.x,
      fromYDataValue: fromPointObj.config.y,
      fromLabel: pluck(fromPointObj.config.displayValue, fromPointObj.config.id),
      toXValue: NumberFormatter.dataLabels(toPointObj.config.x),
      toYValue: NumberFormatter.dataLabels(toPointObj.config.y),
      toXDataValue: toPointObj.config.x,
      toYDataValue: toPointObj.config.y,
      toLabel: pluck(toPointObj.config.displayValue, toPointObj.config.id)
    });

    fromConf = fromPointObj.config;
    toConf = toPointObj.config;

    startConnectors = fromConf.startConnectors || (fromConf.startConnectors = {});
    endConnectors = toConf.endConnectors || (toConf.endConnectors = {});

    id = connector.config.id + '-' + fromConf.id + '-' + toConf.id;

    startConnectors[id] = connector;
    endConnectors[id] = connector;

    pathArr = _getlinePath(connector);
    config.props = {
      element: {
        attr: {
          path: pathArr,
          'stroke-width': strokeWidth,
          'stroke-dasharray': config.dashStyle,
          cursor: config.link ? POINTER : BLANKSTRING,
          stroke: toRaphaelColor(color)
        }
      }
    };
  }
  /**
   * Parse attributes and calculates position during post space management
   *
   * @memberof DragNodeConnector
   */
  allocatePosition () {
    var connectors = this,
      i,
      connector,
      config,
      fromId,
      toId,
      fromPointObj,
      toPointObj,
      manager = connectors.getLinkedParent(),
      connectorStore = connectors.components.data,
      len = connectorStore.length;

    for (i = 0; i < len; i++) {
      connector = connectorStore[i];
      config = connector.config;
      // graphics = connector.graphics || (connector.graphics = {});
      fromId = config.from;
      toId = config.to;
      fromPointObj = manager.getNode(fromId);
      toPointObj = manager.getNode(toId);
      if (fromPointObj && toPointObj && config.deleted !== true) {
        connectors.parsePlotAttributes(connector, fromPointObj, toPointObj, i);
      }
    }
  }
  /**
   * Function to draw individual connectors
   * @param {Object} connector Object having information about the connector that is to be drawn
   * @param {Object} fromPointObj Object having the information about the node from which the connector is to be drawn
   * @param {Object} toPointObj Object having the information about the node to which the connector is to be drawn
   */
  drawConnector (connector) {
    var dataset = this,
      toolTipController = dataset.getFromEnv('toolTipController'),
      animationManager = dataset.getFromEnv('animationManager'),
      graphics = connector.graphics,
      element,
      elementCheck,
      connectorsGroup = dataset.getContainer('connectorGroup'),
      config = connector.config,
      tooltext = config.toolText,
      eventArgs = config.eventArgs || (config.eventArgs = {}),
      conf = dataset.config,
      pool = dataset.components.pool || {};

    if (connector.removed) {
      return;
    }
    element = elementCheck = graphics.graphic;
    if (!graphics.graphic) {
      if (pool.graphic && pool.graphic.path && pool.graphic.path.length) {
        elementCheck = graphics.graphic = pool.graphic.path.shift();
      }
    }
    // draw the line
    element = animationManager.setAnimation({
      el: elementCheck || 'path',
      container: connectorsGroup,
      attr: config.props.element.attr,
      label: 'path',
      component: dataset
    });
    if (!elementCheck) {
      graphics.graphic = element;
      element.on('fc-mousedown', dataset.mouseDown)
        .on('fc-mousemove', dataset.mousemove)
        .on('fc-mouseup', dataset.mouseup)
        .hover(dataset.hoverIn, dataset.hoverOut);
    }
    element.show()
      .data(EVENTARGS, eventArgs)
      .data('viewMode', conf.viewMode)
      .data(configStr, config)
      .data('dataset', dataset);
    conf.showTooltip
      ? toolTipController.enableToolTip(element, tooltext) : toolTipController.disableToolTip(element);
    // If this is not the first render then label is drawn instantly otherwise it is drawn in
    // another thread for performance optimization
    dataset.drawLabel(connector);
  }

  /**
   * Function to draw individual labels of the connector
   * @param {Object} connector Object having information about the connector whose label is to be drawn
   */
  drawLabel (connector) {
    var dataset = this,
      toolTipController = dataset.getFromEnv('toolTipController'),
      // groupManager = dataset.groupManager,
      // nodes = groupManager.nodes,
      conf = dataset.config,
      animationManager = dataset.getFromEnv('animationManager'),
      // chart = dataset.chart,
      // animationObj = chart.get('config', 'animationObj'),
      connectorsGroup = dataset.getContainer('connectorDataLabelGroup'),
      // dummyAnimObj = animationObj.animObj,
      // dummyAnimElem = animationObj.dummyObj,
      // animType = animationObj.animType,
      // animationDuration = animationObj.duration,
      config,
      label,
      tooltext,
      labelAttrs,
      style = dataset.getFromEnv('dataLabelStyle'),
      labelStyle,
      labelElement,
      labelElementCheck,
      graphics,
      connectorObj,
      i,
      labelX,
      labelY,
      textBgColor,
      dataStore = dataset.components.data,
      pool = dataset.components.pool || {},
      len = dataStore.length,
      // fromPointObj,
      // toPointObj,
      // fromId,
      // toId,
      drawIndividualLabel = function (labelConnector) {
        config = labelConnector.config;
        tooltext = config.toolText;
        graphics = labelConnector.graphics;
        label = config.label;
        labelX = config._labelX;
        labelY = config._labelY;

        labelStyle = config.dataLabelStyle || style;
        // fromId = config.from;
        // toId = config.to;
        // fromPointObj = nodes[fromId];
        // toPointObj = nodes[toId];
        textBgColor = config.textBgColor;

        if (label) {
          labelElementCheck = graphics.text = graphics.text || (pool.element && pool.element.text &&
              pool.element.text.shift());
          labelAttrs = {
            text: label,
            fill: labelStyle.color,
            direction: BLANKSTRING,
            cursor: config.link ? POINTER : BLANKSTRING,
            'text-bound': [pluck(labelStyle.backgroundColor, textBgColor),
              pluck(labelStyle.borderColor, textBgColor), 1, '2'
            ],
            x: labelX,
            y: labelY
          };

          // Drawing the connector Label
          labelElement = animationManager.setAnimation({
            el: labelElementCheck || 'text',
            attr: labelAttrs,
            container: connectorsGroup,
            label: 'text',
            component: dataset
          });
          labelElement.show();
          labelElement.outlineText(conf.showTextOutline, labelAttrs.fill);
          if (!labelElementCheck) {
            graphics.text = labelElement;
            labelElement.on('fc-mousedown', dataset.mouseDown)
              .on('fc-mousemove', dataset.mousemove)
              .on('fc-mouseup', dataset.mouseup)
              .hover(dataset.hoverIn, dataset.hoverOut);
          }
          labelElement.data(EVENTARGS, config.eventArgs)
            .data('viewMode', conf.viewMode)
            .data(configStr, config)
            .data('dataset', dataset);
          conf.showTooltip
            ? toolTipController.enableToolTip(labelElement, tooltext) : toolTipController.disableToolTip(labelElement);
        } else {
          graphics.text && graphics.text.hide();
        }
      };

    if (connector) {
      drawIndividualLabel(connector);
    } else {
      for (i = 0; i < len; i++) {
        connectorObj = dataStore[i];
        drawIndividualLabel(connectorObj);
      }
    }
  }

  /**
   * Callback function when mouse is pressed down over the connector
   */
  mouseDown () {
    var ele = this,
      // config = ele.data(configStr),
      dataset = ele.data('dataset'),
      manager = dataset.getLinkedParent();
      // chart = dataset.chart,
      // conf = dataset.config,
      // options = config || {};

    manager.clearLongPress();

    // Whether to fire the click event ot not
    ele.data('fire_click_event', 1);
    manager.triggerConnectorUI(ele);
  }

  /**
   * Callback function when mouse is moved over a connector
   */
  mousemove () {
    var ele = this,
      dataset = ele.data('dataset'),
      manager = dataset.getLinkedParent();
    // Whether to fire the click event ot not
    ele.data('fire_click_event', 0);
    manager.clearLongPress();
  }

  /**
   * Callback function mouse press is released from over a connector
   */
  mouseup () {
    var ele = this,
      dataset = ele.data('dataset'),
      manager = dataset.getLinkedParent();

    manager.clearLongPress();
    // plotEventHandler.call(ele, chart, data, 'ConnectorClick');
  }

  hoverIn (e) {
    var ele = this,
      dataset = ele.data('dataset'),
      chart = dataset.getFromEnv('chart');
    chart.plotEventHandler(ele, e, 'ConnectorRollover');
  }

  hoverOut (e) {
    var ele = this,
      dataset = ele.data('dataset'),
      chart = dataset.getFromEnv('chart');
    chart.plotEventHandler(ele, e, 'ConnectorRollout');
  }

  /**
   * Function to draw arrow heads for the connectors
   * @param {number} X1 The required dimenions for drawing the arrow head
   * @param {number} Y1 The required dimenions for drawing the arrow head
   * @param {number} X2 The required dimenions for drawing the arrow head
   * @param {number} Y2 The required dimenions for drawing the arrow head
   * @param {number} R The required dimenions for drawing the arrow head
   * @param {number} H The required dimenions for drawing the arrow head
   * @return {Array} contains the path coordinates
   */
  static _drawArrow (X1, Y1, X2, Y2, R, H) {
    var tanganent = (Y1 - Y2) / (X1 - X2),
      angle = Math.atan(tanganent),
      PX, PY, RHlf, HHlf,
      arr = [];

    // make all angle as positive
    if (angle < 0) {
      angle = (2 * Math.PI) + angle;
    }
    if (Y2 > Y1) { // PI >angle > 0
      if ((X2 >= X1 && angle > Math.PI) || (X2 < X1 && angle > Math.PI)) {
        angle = angle - Math.PI;
      }
    } else { /// PI <= angle < 360 || angle == 0
      // angle may not be 360 in that case it will be 0 as atan work
      if ((X2 >= X1 && angle < Math.PI && angle !== 0) || (X2 < X1 && angle < Math.PI)) {
        angle = angle + Math.PI;
      }
    }

    if (typeof H === 'undefined') {
      // arrow start point
      PX = X1 + (R * Math.cos(angle));
      PY = Y1 + (R * Math.sin(angle));
    } else { // rectangle
      RHlf = Math.abs(R) / 2;
      HHlf = Math.abs(H) / 2;

      // asume it will intersect a vertical side
      PX = X1 + (RHlf = X1 < X2 ? RHlf : -RHlf);
      PY = Y1 + (RHlf * Math.tan(angle));
      // validate PY
      // if not validate then it will cross the horizontal axis
      if (Math.abs(Y1 - PY) > Math.abs(HHlf)) {
        PY = Y1 + (HHlf = Y1 < Y2 ? HHlf : -HHlf);
        PX = X1 + (HHlf / Math.tan(angle));
      }
    }

    arr.push(L, PX, PY,
      // arrowone half
      PX + (10 * Math.cos(angle + 0.79)),
      PY + (10 * Math.sin(angle + 0.79)),
      // arrowone half
      M, PX + (10 * Math.cos(angle - 0.79)),
      PY + (10 * Math.sin(angle - 0.79)),
      // return to th eedege
      L, PX, PY);

    return arr;
  }

  /**
   * Function to remove data during update if number of data has reduced than the previous render
   * @param {number} indexVal The data index from which data has to be removed.
   * @param {number} stretch The index upto which data has to be removed
   */
  removeData (indexVal, stretch) {
    var dataset = this,
      index = indexVal,
      components = dataset.components,
      dataStore = components.data;

    if (index < 0) {
      index = 0;
    }
    components.removeDataArr = dataStore.splice(index, stretch);
  }

  /**
   * function to Remove data plots if the number of current data plots/categories
   * is more than the existing ones.
   * @param  {Object} datasetJSON JSON for dataset configurations
   */
  trimData (datasetJSON) {
    if (!this.config.JSONData) {
      return;
    }
    let dataSet = this,
      prevData = dataSet.components,
      prevDataLength = prevData.data && prevData.data.length,
      currDataLength = (datasetJSON.connector && datasetJSON.connector.length) || 0,
      dataDiff = prevDataLength - currDataLength;

    // Removing data plots if the number of current data plots/categories
    // is more than the existing ones.
    if (dataDiff > 0) {
      dataSet.removeData(currDataLength, dataDiff);
    }
  }
}
export default DragNodeConnector;
